var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronThinUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-thin-up"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    className: "cls-1",
    points: "16 12.59 6.33 22 5 20.71 16 10 27 20.71 25.67 22 16 12.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronThinUp);
export default __webpack_public_path__ + "static/media/chevron-thin-up.8eb28c19.svg";
export { ForwardRef as ReactComponent };